module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages-home"
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), (_vm.props && !_vm.loading) ? _c('div', {
    staticClass: "pages-content"
  }, [_c('Header'), _c('div', {
    staticClass: "main_content"
  }, [_c('div', {
    staticClass: "homeslider_section"
  }, [(_vm.props.acf.home_slide_img_1) ? _c('div', {
    staticClass: "homeslide",
    style: ({
      backgroundImage: 'url(' + _vm.props.acf.home_slide_img_1 + ')'
    })
  }, [_c('div', {
    staticClass: "herooverlay"
  })]) : _vm._e(), (_vm.props.acf.home_slide_img_2) ? _c('div', {
    staticClass: "homeslide",
    style: ({
      backgroundImage: 'url(' + _vm.props.acf.home_slide_img_2 + ')'
    })
  }, [_c('div', {
    staticClass: "herooverlay"
  })]) : _vm._e(), _c('div', {
    staticClass: "homeslidecaptions"
  }, [_c('div', {
    staticClass: "manual_container"
  }, [_c('div', {
    staticClass: "herologo"
  }, [(_vm.props.acf.home_slide_logo) ? _c('img', {
    attrs: {
      "src": _vm.props.acf.home_slide_logo,
      "alt": ""
    }
  }) : _vm._e(), _c('div', {
    staticClass: "herotitle"
  }, [(_vm.props.acf.home_slide_title) ? _c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.home_slide_title)
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "hero_divider"
  }, [(_vm.props.acf.home_slide_divider) ? _c('img', {
    attrs: {
      "src": _vm.props.acf.home_slide_divider,
      "alt": ""
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "hero_subtitle"
  }, [(_vm.props.acf.home_slide_subtitle) ? _c('h4', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.home_slide_subtitle)
    }
  }) : _vm._e()])])])])]), _c('div', {
    staticClass: "home_welcome"
  }, [_c('div', {
    staticClass: "manual_container"
  }, [(_vm.props.acf.welcome_section_title) ? _c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.welcome_section_title)
    }
  }) : _vm._e(), _c('div', {
    staticClass: "hero_divider"
  }, [(_vm.props.acf.welcome_section_divider_img) ? _c('img', {
    attrs: {
      "src": _vm.props.acf.welcome_section_divider_img,
      "alt": ""
    }
  }) : _vm._e()]), (_vm.props.acf.welcome_section_intro) ? _c('div', {
    staticClass: "introwelcome",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.welcome_section_intro)
    }
  }) : _vm._e(), _c('div', {
    staticClass: "welcome_cta"
  }, [_c('span', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modal1",
      modifiers: {
        "modal1": true
      }
    }]
  }, [(_vm.props.acf.welcome_section_btn_text) ? _c('span', {
    staticClass: "btnmodel2",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.welcome_section_btn_text)
    }
  }) : _vm._e()])]), _c('div', {
    staticClass: "serviceslist"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-sm-6"
  }, [_c('div', {
    staticClass: "homegalleryimg",
    style: ({
      backgroundImage: 'url(' + _vm.props.acf.service_1_bg_img + ')'
    })
  }, [(_vm.props.acf.service_1_url) ? _c('router-link', {
    attrs: {
      "to": _vm.props.acf.service_1_url
    }
  }, [_c('div', {
    staticClass: "homegallery_overlay"
  }, [(_vm.props.acf.service_hover_icon) ? _c('img', {
    attrs: {
      "src": _vm.props.acf.service_hover_icon,
      "alt": ""
    }
  }) : _vm._e(), _c('div', {
    staticClass: "homegallery_content"
  }, [(_vm.props.acf.service_1_title) ? _c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.service_1_title)
    }
  }) : _vm._e()])])]) : _vm._e()], 1)]), _c('div', {
    staticClass: "col-md-6 col-sm-6"
  }, [_c('div', {
    staticClass: "homegalleryimg",
    style: ({
      backgroundImage: 'url(' + _vm.props.acf.service_2_bg_img + ')'
    })
  }, [(_vm.props.acf.service_2_url) ? _c('router-link', {
    attrs: {
      "to": _vm.props.acf.service_2_url
    }
  }, [_c('div', {
    staticClass: "homegallery_overlay"
  }, [(_vm.props.acf.service_hover_icon) ? _c('img', {
    attrs: {
      "src": _vm.props.acf.service_hover_icon,
      "alt": ""
    }
  }) : _vm._e(), _c('div', {
    staticClass: "homegallery_content"
  }, [(_vm.props.acf.service_2_title) ? _c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.service_2_title)
    }
  }) : _vm._e()])])]) : _vm._e()], 1)]), _c('div', {
    staticClass: "col-md-6 col-sm-6"
  }, [_c('div', {
    staticClass: "homegalleryimg",
    style: ({
      backgroundImage: 'url(' + _vm.props.acf.service_3_bg_img + ')'
    })
  }, [(_vm.props.acf.service_2_url) ? _c('router-link', {
    attrs: {
      "to": _vm.props.acf.service_3_url
    }
  }, [_c('div', {
    staticClass: "homegallery_overlay"
  }, [(_vm.props.acf.service_hover_icon) ? _c('img', {
    attrs: {
      "src": _vm.props.acf.service_hover_icon,
      "alt": ""
    }
  }) : _vm._e(), _c('div', {
    staticClass: "homegallery_content"
  }, [(_vm.props.acf.service_3_title) ? _c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.service_3_title)
    }
  }) : _vm._e()])])]) : _vm._e()], 1)]), _c('div', {
    staticClass: "col-md-6 col-sm-6"
  }, [_c('div', {
    staticClass: "homegalleryimg",
    style: ({
      backgroundImage: 'url(' + _vm.props.acf.service_4_bg_img + ')'
    })
  }, [_c('a', {
    staticClass: "clickservice",
    on: {
      "click": function($event) {
        _vm.service1Click()
      }
    }
  }, [_c('div', {
    staticClass: "homegallery_overlay"
  }, [(_vm.props.acf.service_hover_icon) ? _c('img', {
    attrs: {
      "src": _vm.props.acf.service_hover_icon,
      "alt": ""
    }
  }) : _vm._e(), _c('div', {
    staticClass: "homegallery_content"
  }, [(_vm.props.acf.service_4_title) ? _c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.service_4_title)
    }
  }) : _vm._e()])])])])])])])])]), (_vm.props.acf.home_parallax_1_img) ? _c('div', {
    staticClass: "parralaximg",
    style: ({
      backgroundImage: 'url(' + _vm.props.acf.home_parallax_1_img + ')'
    })
  }) : _vm._e(), _c('div', {
    staticClass: "home_meetdoctor",
    attrs: {
      "id": "our-doctor"
    }
  }, [_c('div', {
    staticClass: "manual_container"
  }, [(_vm.props.acf.home_meet_doctor_title) ? _c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.home_meet_doctor_title)
    }
  }) : _vm._e(), _c('div', {
    staticClass: "hero_divider"
  }, [(_vm.props.acf.home_meet_doctor_divider) ? _c('img', {
    attrs: {
      "src": _vm.props.acf.home_meet_doctor_divider,
      "alt": ""
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('div', {
    staticClass: "accordion accordionmanual",
    attrs: {
      "role": "tablist"
    }
  }, _vm._l((_vm.props.acf.meet_doctor_list), function(MeetDoctorList, id) {
    return _c('b-card', {
      staticClass: "mb-1",
      attrs: {
        "no-body": ""
      }
    }, [_c('b-card-header', {
      staticClass: "p-1",
      attrs: {
        "header-tag": "headerr",
        "role": "tab"
      }
    }, [_c('div', {
      directives: [{
        name: "b-toggle",
        rawName: "v-b-toggle",
        value: ('accordion' + id),
        expression: "'accordion' + id"
      }],
      staticClass: "btnaccordion",
      attrs: {
        "block": "",
        "variant": "info"
      }
    }, [(MeetDoctorList.title) ? _c('span', {
      domProps: {
        "innerHTML": _vm._s(MeetDoctorList.title)
      }
    }) : _vm._e()])]), _c('b-collapse', {
      attrs: {
        "accordion": "my-accordion",
        "role": "tabpanel",
        "id": 'accordion' + id
      }
    }, [_c('b-card-body', [_c('span', {
      staticClass: "b-card-text"
    }, [(MeetDoctorList.content) ? _c('span', {
      domProps: {
        "innerHTML": _vm._s(MeetDoctorList.content)
      }
    }) : _vm._e()])])], 1)], 1)
  }))]), (_vm.props.acf.meet_doctor_right_img) ? _c('div', {
    staticClass: "col-sm-4 doctor_img",
    style: ({
      backgroundImage: 'url(' + _vm.props.acf.meet_doctor_right_img + ')'
    })
  }) : _vm._e()])])]), (_vm.props.acf.home_parallax_2_img) ? _c('div', {
    staticClass: "parralaximg",
    style: ({
      backgroundImage: 'url(' + _vm.props.acf.home_parallax_2_img + ')'
    })
  }) : _vm._e(), _c('div', {
    staticClass: "meetteam_section",
    attrs: {
      "id": "our-team"
    }
  }, [_c('div', {
    staticClass: "manual_container"
  }, [(_vm.props.acf.home_team_title) ? _c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.home_team_title)
    }
  }) : _vm._e(), _c('div', {
    staticClass: "hero_divider"
  }, [(_vm.props.acf.home_team_divider) ? _c('img', {
    attrs: {
      "src": _vm.props.acf.home_team_divider,
      "alt": ""
    }
  }) : _vm._e()]), (_vm.props.acf.home_team_intro) ? _c('div', {
    staticClass: "team_intro",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.home_team_intro)
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "teammember_list"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.props.acf.home_team_list), function(TeamemberList, index) {
    return (_vm.props.acf.home_team_list) ? _c('div', {
      staticClass: "col-md-3 col-sm-6"
    }, [_c('div', {
      staticClass: "team_member",
      style: ({
        backgroundImage: 'url(' + TeamemberList.image + ')'
      })
    }, [_c('div', {
      staticClass: "team_name",
      domProps: {
        "innerHTML": _vm._s(TeamemberList.name)
      }
    }), _c('div', {
      staticClass: "bio"
    }, [_c('div', {
      staticClass: "bio_content"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(TeamemberList.name)
      }
    }), (_vm.props.acf.team_divider_img) ? _c('hr', {
      style: ({
        backgroundImage: 'url(' + _vm.props.acf.team_divider_img + ')'
      })
    }) : _vm._e(), _c('span', {
      domProps: {
        "innerHTML": _vm._s(TeamemberList.designation)
      }
    })])])])]) : _vm._e()
  }))])]), (_vm.props.acf.home_parallax_3_img) ? _c('div', {
    staticClass: "parralaximg",
    style: ({
      backgroundImage: 'url(' + _vm.props.acf.home_parallax_3_img + ')'
    })
  }) : _vm._e(), _c('div', {
    staticClass: "testimonials_section",
    attrs: {
      "id": "our-testimonials"
    }
  }, [_c('div', {
    staticClass: "manual_container"
  }, [(_vm.props.acf.home_testimonial_title) ? _c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.home_testimonial_title)
    }
  }) : _vm._e(), _c('div', {
    staticClass: "hero_divider"
  }, [(_vm.props.acf.home_testimonial_divider) ? _c('img', {
    attrs: {
      "src": _vm.props.acf.home_testimonial_divider,
      "alt": ""
    }
  }) : _vm._e()]), (_vm.props.acf.testimonial_list) ? _c('div', {
    staticClass: "testimonial_slider"
  }, [_c('swiper', {
    attrs: {
      "options": _vm.swiperOption2
    }
  }, [_vm._l((_vm.props.acf.testimonial_list), function(testimonailSlider) {
    return _c('swiper-slide', [_c('div', {
      staticClass: "slideinner"
    }, [_c('div', {
      staticClass: "desc-testimonial",
      domProps: {
        "innerHTML": _vm._s(testimonailSlider.description)
      }
    }), _c('h4', [_c('span', [_vm._v("- ")]), _c('span', {
      domProps: {
        "innerHTML": _vm._s(testimonailSlider.title)
      }
    })])])])
  }), _c('div', {
    staticClass: "swiper-button-prev swiper-button-black",
    attrs: {
      "slot": "button-prev"
    },
    slot: "button-prev"
  }), _c('div', {
    staticClass: "swiper-button-next swiper-button-black",
    attrs: {
      "slot": "button-next"
    },
    slot: "button-next"
  })], 2)], 1) : _vm._e()])])]), _c('Footer')], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-726ad83e","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/pages/home/home.pug
// module id = 827
// module chunks = 1